export default "__VITE_ASSET__1f49cbeb__"